import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useAuth } from "@mhj/shared/auth";
import EmpowermentShell from "./components/EmpowermentShell";
import Landing from "./routes/Landing";
import Register from "./routes/Register";
import Login from "./routes/Login";
import VerifyPhone from "./routes/VerifyPhone";
import Apply from "./routes/Apply";
import Dashboard from "./routes/Dashboard";
import OfficerCapture from "./routes/OfficerCapture";
import PublicStatus from "./routes/PublicStatus";
import Results from "./routes/Results";
import ClaimAccount from "./routes/ClaimAccount";
import NotFound from "./routes/NotFound";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route element={<EmpowermentShell />}>
        <Route path="/" element={<Landing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-phone" element={<VerifyPhone />} />
        <Route path="/claim" element={<ClaimAccount />} />
        <Route path="/status" element={<PublicStatus />} />
        <Route path="/results" element={<Results />} />
        <Route
          path="/apply"
          element={
            <RequireAuth>
              <Apply />
            </RequireAuth>
          }
        />
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/capture"
          element={
            <RequireAuth>
              <OfficerCapture />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
